
import person from "@/apiCallers/person";
import predmeti from "@/apiCallers/promise_handler_db/predmeti.js";
import { store } from "@/vuex/store.js"
import auth from "@/services/auth";

var curr_user_permission = []


export default
    {
        // Check if user has reloaded window 
        // If it is reloaded get self
        // It can be used for every view
        checkUserInfo: async function () {
            if (
                store.state.logged_in_user == undefined ||
                store.state.logged_in_user == null
            ) {
                let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
                await person.getSelf(accessToken).then((resp) => {
                    store.state.logged_in_user = resp.data;
                });
            }
            store.state.curr_user_permission = store.state.logged_in_user.user_role.application_permission.map((p) => p.permission_id)

        },
        // Check if current signed in user is allowed to see view
        check_application_permission: async function (wanted_permission) {
            // console.log(store.state.curr_user_permission)
            return (store.state.curr_user_permission.includes(wanted_permission))
        },
        // Check if current signed in user is allowed to see view
        getUserCasePermissions: async function (case_id) {
            await predmeti.getUserCasePermissions(case_id, store.state.logged_in_user.uid).then((resp) => {
                // console.log(resp.data)
            })
        },

        // check if user can see everything
        // if he's got this permission he can override normal case and project permissions
        can_user_override: async function () {
            return (store.state.curr_user_permission.includes("application.all"))
        },

        // Save current opened project state
        save_project_permission: function (proj_id, available_permissions) {
            if (store.state.user_project_permissions != undefined ||
                store.state.user_project_permissions == null) {
                store.state.user_project_permissions = {
                    proj_id,
                    available_permissions
                }
            }
            else if (store.state.user_project_permissions.proj_id != proj_id) {
                store.state.user_project_permissions = {
                    proj_id,
                    available_permissions
                }
            }
        },
        // Save current opened project state
        save_case_permission: function (case_id, available_permissions) {
            if (store.state.mapped_case_permission != undefined ||
                store.state.mapped_case_permission == null) {
                store.state.mapped_case_permission = {
                    case_id,
                    available_permissions
                }
            }
            else if (store.state.mapped_case_permission.case_id != case_id) {
                store.state.mapped_case_permission = {
                    case_id,
                    available_permissions
                }
            }
        },


        // Check saved permissions for project
        // Check if wanted permission for selected is inside array
        check_project_permission: function (wanted_permission) {

            if (store.state.user_project_permissions == undefined) {
                return true
            }
            if (store.state.logged_in_user.user_role.id == 1) {
                return true;
            } else
                return (store.state.user_project_permissions.available_permissions.includes(wanted_permission))
        },

        // Check saved permissions for project
        // Check if wanted permission for selected is inside array
        check_case_permsision: function (wanted_permission) {

            // console.log(wanted_permission, store.state.mapped_case_permission,store.state.mapped_case_permission.available_permissions.includes(wanted_permission))
            if (store.state.mapped_case_permission == undefined) {
                return true
            }
            if (store.state.logged_in_user.user_role.id == 1) {
                return true;
            } else
                return (store.state.mapped_case_permission.available_permissions.includes(wanted_permission))
        }
    }